"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _inverseFieldPositioning = _interopRequireDefault(require("./inverseFieldPositioning"));

var _adjustFieldPositioning = _interopRequireDefault(require("./adjustFieldPositioning"));

var _repositionFields = _interopRequireDefault(require("./repositionFields"));

var _resizeFields = _interopRequireDefault(require("./resizeFields"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var updateFieldLayout = function updateFieldLayout(pageDimensions, field) {
  var originalDimensions = pageDimensions.originalDimensions,
      updatedDimensions = pageDimensions.updatedDimensions;

  var newField = _objectSpread({}, field); // Inverse Coordinates
  // So that we can use css: top
  // The raw data we get sends points from the bottom of image
  // To the top of the field


  var inversedFieldCoordinates;

  if (newField.fieldType === 'RDO') {
    inversedFieldCoordinates = {
      radioGroupItems: []
    };
    newField.radioGroupItems.forEach(function (radioField) {
      inversedFieldCoordinates.radioGroupItems.push(_objectSpread({}, radioField, (0, _inverseFieldPositioning.default)(originalDimensions, radioField)));
    });
  } else {
    inversedFieldCoordinates = (0, _inverseFieldPositioning.default)(originalDimensions, newField);
  }

  newField = _objectSpread({}, newField, inversedFieldCoordinates); // Reposition fields for page resizing
  // Raw data gives us a reference size to base this off of

  var repositionedFieldCoordinates;

  if (newField.fieldType === 'RDO') {
    repositionedFieldCoordinates = {
      radioGroupItems: []
    };
    newField.radioGroupItems.forEach(function (radioField) {
      repositionedFieldCoordinates.radioGroupItems.push(_objectSpread({}, radioField, (0, _repositionFields.default)(pageDimensions, radioField)));
    });
  } else {
    repositionedFieldCoordinates = (0, _repositionFields.default)(pageDimensions, newField);
  }

  newField = _objectSpread({}, newField, repositionedFieldCoordinates); // Adjust Coordinates
  // Raw data does not place fields in correct spot
  // We need to bump them a bit based on the page dimensions

  var adjustedFieldCoordinates;

  if (newField.fieldType === 'RDO') {
    adjustedFieldCoordinates = {
      radioGroupItems: []
    };
    newField.radioGroupItems.forEach(function (radioField) {
      adjustedFieldCoordinates.radioGroupItems.push(_objectSpread({}, radioField, (0, _adjustFieldPositioning.default)(updatedDimensions, radioField)));
    });
  } else {
    adjustedFieldCoordinates = (0, _adjustFieldPositioning.default)(updatedDimensions, newField);
  }

  newField = _objectSpread({}, newField, adjustedFieldCoordinates); // Resize fields for page resizing
  // Raw data gives us a referense size to base this off of

  var resizedFieldSizes;

  if (newField.fieldType === 'RDO') {
    resizedFieldSizes = {
      radioGroupItems: []
    };
    newField.radioGroupItems.forEach(function (radioField) {
      resizedFieldSizes.radioGroupItems.push(_objectSpread({}, radioField, (0, _resizeFields.default)(pageDimensions, radioField)));
    });
  } else {
    resizedFieldSizes = (0, _resizeFields.default)(pageDimensions, newField);
  }

  newField = _objectSpread({}, newField, resizedFieldSizes);
  return newField;
};

var _default = updateFieldLayout;
exports.default = _default;